<template>
  <b-container fluid>
    <b-overlay :show="unitLoad">
    <b-row>
      <!-- <b-col lg="12" sm="12"> -->
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12" class="form-for-textarea">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                        <b-table-simple striped bordered small>
                            <b-tr style="background-color: #66CC99; color: white">
                                <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                <b-th>{{ $t('production_store.pro_category') }}</b-th>
                                <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                                <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                                <b-th>{{ $t('retailerManagement.delivery_quantity') }}</b-th>
                                <!-- <b-th v-if="dataArray.return_mode">{{ $t('externalUser.production.returned_qty') }}</b-th> -->
                                <b-th>{{ $t('retailerManagement.received_quantity') }}</b-th>
                                <b-th>{{ $t('retailerManagement.receive_quantity') }}</b-th>
                                <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                                <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                            </b-tr>
                            <b-tr v-for="(item, index) in dataArray.delivery_details" :key="index">
                                <b-td>{{ $n(index + 1) }}</b-td>
                                <b-td>{{ getCategoryName(item.product_id) }}</b-td>
                                <b-td>{{ productNameById(item.product_id) }}</b-td>
                                <b-td>{{ unitNameById(item.unit_id) }}</b-td>
                                <b-td>{{ $n(item.quantity - item.returned_quantity) }}</b-td>
                                <!-- <b-td v-if="dataArray.return_mode">{{ $n(item.returned_quantity) }}</b-td> -->
                                <b-td>{{ $n(item.received_quantity) }}</b-td>
                                <b-td>
                                    <ValidationProvider name="Receive Quantity" :vid="'receive_quantity'+index"
                                      :rules="'max_value:'+(parseInt(item.quantity) - (parseInt(item.received_quantity) + item.returned_quantity))+'|min_value:0|numeric|required'"
                                    >
                                        <b-form-group
                                          slot-scope="{ valid, errors }"
                                          class="mb-0"
                                        >
                                            <b-form-input
                                              type="number"
                                              v-model="item.receive_quantity"
                                              @input="changeQty(item)"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                              {{ errors[0] }}
                                            </div>
                                            <div class="invalid-feedback d-block">
                                                {{ item.message }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-td>
                                <b-td>{{ $n(item.unit_price) }}</b-td>
                                <b-td>{{ $n(item.total) }}</b-td>
                            </b-tr>
                            <!-- <b-td :colspan="dataArray.return_mode < 1 ? '7' : '8'"> -->
                            <b-td colspan="8">
                                <p style="margin-left:85%">{{ $t('sales_distribution_admin.grand_price') }}</p>
                            </b-td>
                            <b-td>{{ $n(dataArray.sumTotal) }}</b-td>
                        </b-table-simple>
                        <b-row>
                          <b-col lg="6" sm="12">
                            <ValidationProvider name="Receive Date" vid='receive_date' rules="required">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="receive_date"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('retailerManagement.receive_date')}} <span class="text-danger">*</span>
                              </template>
                              <flat-pickr
                                class="form-control disabled"
                                id="receive_date"
                                placeholder="Select Date"
                                v-model="dataArray.receive_date"
                                :state="errors[0] ? false : (valid ? true : null)"
                              >
                              </flat-pickr>
                                <div class="invalid-feedback d-block">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                              </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="12"></b-col>
                          <b-col lg="6" sm="12">
                              <ValidationProvider name="Comment (En)" vid='comments'>
                                  <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="comments"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('production_store.comment_en')}}
                                  </template>
                                  <b-textarea
                                  id="note"
                                  v-model="dataArray.comments"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12">
                              <ValidationProvider name="Comment (Bn)" vid='comments_bn'>
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                      label-for="comments_bn"
                                      slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                        {{ $t('production_store.comment_bn')}}
                                      </template>
                                      <b-textarea
                                      id="comments_bn"
                                      v-model="dataArray.comments_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-textarea>
                                      <div class="invalid-feedback">
                                        {{ errors[0] }}
                                      </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                            </b-row>
                            <div class="row">
                        <div class="col-sm-3"></div>
                        <div class="col text-right">
                          <b-button type="submit" variant="primary" class="mr-1">{{ $t('sales_center.receive') }}</b-button>
                          &nbsp;
                          <b-button variant="danger" @click="$bvModal.hide('modal-receive')">{{ $t('globalTrans.cancel') }}</b-button>
                        </div>
                      </div>
                    </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      <!-- </b-col> -->
    </b-row>
  </b-overlay>
  </b-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { deliveryReceiveStoreAdminApi } from '../../api/routes'
import { core } from '@/config/pluginInit'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      dataArray: {
        receive_date: '',
        comments: '',
        comments_bn: '',
        sumTotal: 0
      },
      unitLoad: false,
      validQty: true
    }
  },
  computed: {
    currentLocale: function () {
        return this.$i18n.locale
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getQuotationData()
      this.dataArray = tmp
      this.getGrandTotal()
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    getGrandTotal () {
      let sumM = 0
      this.dataArray.delivery_details.forEach(function (data) {
        sumM = sumM + parseFloat(data.total)
      })
      this.dataArray.sumTotal = parseFloat(sumM) ? sumM : 0
    },
    changeQty (item) {
        const result = parseFloat(item.receive_quantity) * parseFloat(item.unit_price)
        item.total = parseFloat(result.toFixed(2))
        this.getGrandTotal()
    },
    validQuantity (item) {
      let total = 0
      if (item.received_quantity) {
          total = parseInt(item.quantity) - parseInt(item.received_quantity)
      } else {
          total = parseInt(item.quantity)
      }
      if (total < parseInt(item.receive_quantity)) {
          item.message = 'Receive quantity must be smaller than delivery quantity'
          this.validQty = false
      } else {
          item.message = ''
          this.validQty = true
      }
      this.changeQty(item)
    },
    getQuotationData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      const tmp = JSON.parse(JSON.stringify(tmpData))
      const newData = tmp.delivery_details.map(item => {
        const returnQty = item.returned_quantity ? parseInt(item.returned_quantity) : 0
        const rcvQty = item.received_quantity ? item.received_quantity : 0
        return Object.assign(item, {}, { total: 0, returned_quantity: returnQty, received_quantity: rcvQty, receive_quantity: 0 })
      })
      return Object.assign({}, tmp, { delivery_details: newData })
    },
    getCategoryName (Id) {
      const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.$store.state.ProductionService.commonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    productNameById (id) {
        const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
      const unit = this.$store.state.ProductionService.commonObj.productUnitList.find(unit => unit.value === id)
      if (this.$i18n.locale === 'bn') {
          return unit.text_bn
      } else {
          return unit.text_en
      }
    },
    async saveData () {
      if (this.validQty === true) {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          let result = null
          const loadingState = { loading: false, listReload: false }
          this.unitLoad = true
          if (this.id) {
              result = await RestApi.postData(productionServiceBaseUrl, deliveryReceiveStoreAdminApi, this.dataArray)
          }

          loadingState.listReload = true
          this.$store.dispatch('mutateCommonProperties', loadingState)
          this.unitLoad = false
          if (result.success) {
              if (result.notification && this.$store.state.emitNotification) {
                  const notification = result.notification
                  this.$socket.emit('send-notification', notification)
              }
              this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
              })
              this.$bvModal.hide('modal-receive')
          } else {
              this.$toast.error({
                  title: this.$t('globalTrans.error'),
                  message: result.message,
                  color: '#D6E09B'
              })
              this.$refs.form.setErrors(result.errors)
          }
      }
    }
  }
}
</script>
